<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>推广邀请</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content" style="margin:5px">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle :loading="state" @click="refresh"></el-button>
          <el-popover placement="top-start"  trigger="hover" :content="shareLink" style="margin:0 15px 0 15px">
            <el-button slot="reference" type="primary" size="small" class="icon-copy" v-clipboard:copy="shareLink" v-clipboard:success="onCopyLink"><i class="el-icon-share" style="margin-right:5px"></i>复制邀请链接</el-button>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" content="邀请人可享受，被邀请人消费金额的20%提成。提成只能用于平台消费">
            <el-button slot="reference" type="info" size="small" >邀请说明<i class="iconfont icon-wenhaoxiao" style="font-size:12px;margin:0 0 0 5px"></i></el-button>
          </el-popover>
        </el-card>
      </div>

      <el-form :inline="true" :model="queryInfo" class="demo-form-inline" ref="searchFormRef" size="small" style="margin:20px 0">
        <el-form-item label="注册邮箱" prop="email">
          <el-input v-model="queryInfo.email"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>
      <el-table :data="inviteeList" v-loading="loading" border style="width: 100%"  stripe>
        <el-table-column prop="email" label="被邀请人邮箱"></el-table-column>
        <el-table-column prop="createDate" label="注册时间"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data(){
    return{
      state:false,
      loading:true,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      inviteeList: [],
      total: 0,
      inputWidth: false,
      shareLink:""
    }
  },
  created(){
    this.$nextTick(()=>{
      if (document.body.clientWidth < 700){
        this.inputWidth = true
      }
    })
    this.getRef()
    this.shareLink = `http://developer.7ccccccc.com/register?ref=${window.sessionStorage.getItem('shareId')}`
  },
  methods: {
    onCopyLink(e) {
      this.$message.success('邀请注册链接已复制到剪贴板!')
    },
    async getRef(){
      this.state = true
      const result = await this.$http.get("getinvitee", {
        params: this.queryInfo
      });
      if (!result.data.data.total) {
        this.state = false
        this.total = 0
        this.inviteeList = []
        this.loading = false
        return
      }
      console.log("result: ", result);
      this.state = false
      this.inviteeList = result.data.data.data.map(element =>{
        if (element.createDate) {
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        return element
      })
      this.total = result.data.data.total
      this.loading = false
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getRef()
    },
    refresh(){
      this.getRef()
    },
    reSet(){
      this.queryInfo.email = ""
      this.$refs.searchFormRef.resetFields()
      this.getRef()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getRef()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getRef()
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.navbtn{
  margin-bottom: 20px;
}
</style>